// Mock data for Moroccan Brothers CRM (frontend-only teaser).
// Replace with backend data later. See contracts.md when backend is added.

export const BRAND = {
  name: "Moroccan Brothers",
  tagline: "Guiding Wealth & Growing Legacies",
  logo: "https://customer-assets.emergentagent.com/job_maroc-dashboard/artifacts/28ef48x3_Untitled%20design.png",
};

// Loom walkthrough: "How to add your own Claude API key". Swap this with your real Loom share link.
export const LOOM_HELP_URL = "";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1628962601069-ffe240250c35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxNYXJyYWtlY2glMjByaWFkfGVufDB8fHx8MTc4MjM0MDg0NXww&ixlib=rb-4.1.0&q=85";

const propertyImages = [
  "https://images.unsplash.com/photo-1565020244281-fe53df7df170?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxNYXJyYWtlY2glMjByaWFkfGVufDB8fHx8MTc4MjM0MDg0NXww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/15531322/pexels-photo-15531322.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1570133435807-5feefeb2d196?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwcm9wZXJ0eSUyME1vcm9jY298ZW58MHx8fHwxNzgyMzQwODQ1fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxNb3JvY2NhbiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODIzNDA4NDV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/13766862/pexels-photo-13766862.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwcm9wZXJ0eSUyME1vcm9jY298ZW58MHx8fHwxNzgyMzQwODQ1fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/15531226/pexels-photo-15531226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const USER = {
  name: "Yassine El Amrani",
  email: "yassine@moroccanbrothers.com",
  role: "Head of Acquisitions",
  avatar: "https://i.pravatar.cc/120?img=12",
};

export const STAGES = [
  { id: "sourced", label: "Sourced", color: "#7c8a99" },
  { id: "contacted", label: "Contacted", color: "#3b82f6" },
  { id: "viewing", label: "Viewing", color: "#f59e0b" },
  { id: "negotiating", label: "Negotiating", color: "#e63946" },
  { id: "closing", label: "Closing", color: "#1aa860" },
  { id: "acquired", label: "Acquired", color: "#10b981" },
];

export const AGENT_STAGES = [
  { id: "contact", label: "Contact", color: "#7c8a99" },
  { id: "answered", label: "Answered", color: "#3b82f6" },
  { id: "sous_location", label: "Accepts Sous Location", color: "#a855f7" },
  { id: "active", label: "Active Agent", color: "#1aa860" },
  { id: "disqualified", label: "Disqualified", color: "#e63946" },
  { id: "direct_booking", label: "Got me a direct booking", color: "#10b981" },
];

// Main Moroccan cities used for agent/property tagging + filtering.
export const MOROCCO_CITIES = [
  "Marrakech", "Casablanca", "Tangier", "Tétouan", "Rabat", "Agadir",
  "Fès", "Kénitra", "Meknès", "Essaouira", "Oujda", "El Jadida", "Mohammedia", "Salé", "Other",
];


// Build tel/whatsapp/mailto links from agent contact fields.
export const telHref = (n) => (n && n !== "—" ? `tel:${n.replace(/[^\d+]/g, "")}` : null);
export const waHref = (n) => {
  const d = (n || "").replace(/[^\d]/g, "");
  return d ? `https://wa.me/${d}` : null;
};
export const mailHref = (e) => (e ? `mailto:${e}` : null);

export const KPIS = [
  { id: "pipeline", label: "Pipeline Value", value: "£8.42M", delta: "+12.4%", up: true, sub: "across 42 active deals" },
  { id: "units", label: "Units Acquired", value: "37", delta: "+5 this qtr", up: true, sub: "since launch" },
  { id: "score", label: "Avg AI Deal Score", value: "78", delta: "+3.1", up: true, sub: "out of 100" },
  { id: "yield", label: "Proj. Net Yield", value: "9.6%", delta: "-0.4%", up: false, sub: "blended portfolio" },
];

export const PIPELINE_TREND = [
  { m: "Jan", v: 4.2 }, { m: "Feb", v: 4.9 }, { m: "Mar", v: 5.4 },
  { m: "Apr", v: 5.1 }, { m: "May", v: 6.3 }, { m: "Jun", v: 7.0 },
  { m: "Jul", v: 8.42 },
];

export const PROPERTIES = [
  {
    id: "p1", title: "Riad Zitoun el Jdid", district: "Medina", beds: 6, baths: 5,
    price: 4200000, currency: "MAD", askGbp: 336000, score: 92, stage: "negotiating",
    yield: 11.2, status: "Hot", image: propertyImages[0],
    summary: "Restored 18th-century riad, 6 ensuite rooms, plunge pool. Owner motivated — overseas seller.",
    tags: ["Pool", "Rooftop", "Renovated"],
  },
  {
    id: "p2", title: "Dar Bahia Annex", district: "Bahia", beds: 4, baths: 4,
    price: 2950000, currency: "MAD", askGbp: 236000, score: 84, stage: "viewing",
    yield: 9.8, status: "Warm", image: propertyImages[1],
    summary: "Quiet derb, strong ADR comps. Needs roof terrace works (~£18k).",
    tags: ["Courtyard", "Quiet derb"],
  },
  {
    id: "p3", title: "Kasbah Courtyard House", district: "Kasbah", beds: 8, baths: 7,
    price: 6800000, currency: "MAD", askGbp: 544000, score: 88, stage: "closing",
    yield: 10.4, status: "Hot", image: propertyImages[2],
    summary: "Boutique guesthouse already trading. Transferable licence, 78% occupancy.",
    tags: ["Trading", "Licence", "Pool"],
  },
  {
    id: "p4", title: "Mouassine Townhouse", district: "Mouassine", beds: 3, baths: 2,
    price: 1850000, currency: "MAD", askGbp: 148000, score: 71, stage: "contacted",
    yield: 8.9, status: "Cool", image: propertyImages[3],
    summary: "Compact but central. Good for self-check-in studio conversion.",
    tags: ["Central", "Studio potential"],
  },
  {
    id: "p5", title: "Palmeraie Villa", district: "Palmeraie", beds: 5, baths: 5,
    price: 9500000, currency: "MAD", askGbp: 760000, score: 67, stage: "sourced",
    yield: 7.2, status: "Cool", image: propertyImages[4],
    summary: "Large plot, private pool. Lower yield but strong capital growth story.",
    tags: ["Villa", "Private pool", "Garden"],
  },
  {
    id: "p6", title: "Riad Laksour", district: "Laksour", beds: 5, baths: 4,
    price: 3400000, currency: "MAD", askGbp: 272000, score: 81, stage: "negotiating",
    yield: 10.1, status: "Warm", image: propertyImages[5],
    summary: "Off-market via agent Karim. Tiled courtyard, fountain, needs cosmetic refresh.",
    tags: ["Off-market", "Fountain"],
  },
  {
    id: "p7", title: "Sidi Mimoun Riad", district: "Sidi Mimoun", beds: 7, baths: 6,
    price: 5600000, currency: "MAD", askGbp: 448000, score: 86, stage: "acquired",
    yield: 10.9, status: "Acquired", image: propertyImages[6],
    summary: "Acquired Q2. Now trading at 82% occupancy, ADR £140.",
    tags: ["Acquired", "Trading"],
  },
];

export const AGENTS = [
  { id: "a1", name: "Karim Benali", agency: "Marrakech Prime", phone: "+212 6 61 22 18 04", deals: 9, reliability: 94, hot: 4, lastContact: "2h ago", avatar: "https://i.pravatar.cc/80?img=33" },
  { id: "a2", name: "Salma Idrissi", agency: "Atlas Estates", phone: "+212 6 70 55 31 12", deals: 6, reliability: 88, hot: 2, lastContact: "Yesterday", avatar: "https://i.pravatar.cc/80?img=45" },
  { id: "a3", name: "Omar Tazi", agency: "Medina Keys", phone: "+212 6 12 90 77 65", deals: 11, reliability: 76, hot: 5, lastContact: "3d ago", avatar: "https://i.pravatar.cc/80?img=15" },
  { id: "a4", name: "Nadia Cherkaoui", agency: "Riad Partners", phone: "+212 6 45 80 19 23", deals: 4, reliability: 91, hot: 1, lastContact: "5h ago", avatar: "https://i.pravatar.cc/80?img=20" },
  { id: "a5", name: "Hamza Lahlou", agency: "Independent", phone: "+212 6 33 41 60 88", deals: 7, reliability: 69, hot: 3, lastContact: "1w ago", avatar: "https://i.pravatar.cc/80?img=51" },
];

export const ACTIVITIES = [
  { id: "ac1", type: "score", text: "AI re-scored Riad Zitoun el Jdid to 92 after new occupancy comps.", time: "12m ago" },
  { id: "ac2", type: "deal", text: "Karim Benali moved Riad Laksour to Negotiating.", time: "48m ago" },
  { id: "ac3", type: "message", text: "Owner of Dar Bahia Annex replied — open to £224k.", time: "2h ago" },
  { id: "ac4", type: "win", text: "Sidi Mimoun Riad marked Acquired. Portfolio now 37 units.", time: "1d ago" },
  { id: "ac5", type: "alert", text: "New off-market lead in Mouassine flagged by AI radar.", time: "1d ago" },
];

export const AI_INSIGHTS = [
  { id: "i1", title: "Negotiation lever found", body: "Riad Zitoun seller has held for 9 months and lists overseas. Open at 8% under ask — model gives 71% acceptance.", tone: "red", confidence: 71 },
  { id: "i2", title: "Yield outlier", body: "Kasbah Courtyard House projects 10.4% net vs 8.7% district median. Already trading — fast-track closing.", tone: "green", confidence: 88 },
  { id: "i3", title: "Agent reliability drop", body: "Omar Tazi's close-rate fell to 76%. Two stale leads >7 days. Suggest reassigning Palmeraie Villa.", tone: "red", confidence: 64 },
  { id: "i4", title: "Market timing", body: "Medina riad ask prices up 4.1% QoQ. Lock viewings on warm leads within 14 days.", tone: "green", confidence: 79 },
];

export const TASKS = [
  { id: "t1", text: "Send revised offer — Riad Zitoun el Jdid", due: "Today", priority: "high", done: false },
  { id: "t2", text: "Confirm viewing slot with Salma (Dar Bahia)", due: "Today", priority: "high", done: false },
  { id: "t3", text: "Review survey report — Kasbah Courtyard", due: "Tomorrow", priority: "med", done: false },
  { id: "t4", text: "Chase licence transfer docs", due: "Wed", priority: "med", done: true },
  { id: "t5", text: "Refresh AI comps for Palmeraie", due: "Fri", priority: "low", done: false },
];

export const fmtGbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);
